import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { TopupsApiAdapter } from '../adapters';
import { TopupsFilters, TopupsResponse } from '../models';

const DEFAULT_FILTERS: TopupsFilters = {};

export const TOPUPS_QUERY_KEY = 'topups';

export const useTopups = (
    walletId: number | null | undefined,
    filters?: TopupsFilters
) => {
    const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
    const apiAdapter = useMemo(() => new TopupsApiAdapter(httpClient), [httpClient]);
    const resolvedFilters = filters ?? DEFAULT_FILTERS;

    return useQuery<TopupsResponse, Error>({
        queryKey: [TOPUPS_QUERY_KEY, walletId, resolvedFilters],
        queryFn: () => apiAdapter.getTopups(walletId ?? null, resolvedFilters),
        staleTime: 60 * 1000,
        placeholderData: keepPreviousData,
    });
};

